module.exports = __webpack_public_path__ + "static/media/ourMission1.159ae189.png";